import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OpsappService } from '../../services/opsapp.service';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.css']
})
export class IncidentsComponent implements OnInit {

  @ViewChild(Table) dt: Table;
  incidents: any[] = Array.from({ length: 5 });
  //virtualIncidents: any[] = Array.from({ length: 10000 });
  loading: boolean = false;
  searchText: string = "";
  context: any = this;
  newIncidentModal: boolean = false;
  maxLoaded: number = 0;

  title: string;
  summary: string;
  instruments: any[] = new Array;
  selectedInstrument: any;
  serviceCodes: any[] = new Array;
  selectedServiceCode: any;
  needsServiceChecked: boolean = false;
  outOfService: boolean = false;
  saveIncidentDisabled: boolean = false;

  constructor(private router: Router, 
    private route: ActivatedRoute,
    private opsappService: OpsappService,
    private messageService: MessageService){}

  ngOnInit() {
    //this.loadData(5);
    this.loadInstruments();
  }

  loadInstruments(){
    this.opsappService.getInstruments().then(data => {
      this.instruments = data;
    });
  }

  loadServiceCodes(){
    this.opsappService.getInstrumentServiceCodes(this.selectedInstrument.instrumentId).then(data => {
      this.serviceCodes = data;
    });
  }

  search() {
    this.maxLoaded = 0;
    this.incidents = Array.from({ length: 5 });;
    this.dt.clear();
    this.dt.reset();
    this.dt.resetScrollTop();
  }

  onLazyLoad(event: any){
    //this.loading = true;
    if (this.maxLoaded < event.first + event.rows)
    {
      this.loading = true
      var IncidentsOptions: any = {
        SearchText: this.searchText,
        Offset: event.first
      }

      this.opsappService.getIncidentsList(IncidentsOptions).then(data => {
        this.incidents.splice(event.first, event.rows, ...data);
        event.forceUpdate();
        this.maxLoaded = event.first + event.rows;
        this.incidents.length = this.maxLoaded + 5;
        this.loading = false;
      });
    }
  }

  createIncident()
  {
    this.newIncidentModal = true;
  }

  viewIncident(incident: any){
    this.opsappService.activeIncident.next(incident);
    this.router.navigate(["incident-detail"], { relativeTo: this.route.parent });
  }

  refreshIncidents(){
    //this.router.navigate(["incidents"], { relativeTo: this.route.parent });
    this.searchText = "";
    this.search();
  }

  saveIncident(){
    this.saveIncidentDisabled = true;
    var incident = {
      InstrumentId:this.selectedInstrument.instrumentId,
      InstrumentName: this.selectedInstrument.name,
      InstrumentServiceCodeId: this.selectedServiceCode.instrumentServiceCodeId,
      //Add this if we want the user to be able to change it
      TechnicianName: "",
      Title: this.title,
      Summary: this.summary,
      OutOfService: this.outOfService
    };

    this.opsappService.createIncident(incident).then(data => {
      this.messageService.add({severity:'success', summary:'Incident created successfully!'});
      this.newIncidentModal = false;
      this.saveIncidentDisabled = false;
      this.refreshIncidents();
    }).catch(() => {
      this.messageService.add({severity:'error', summary:'Couldn\'t create a new incident.'});
      this.saveIncidentDisabled = false;
    });
  }

  hasNotes(incident: any){
    return incident?.ticket?.messages.length > 1
  }

  hasAttachments(incident: any){
    const attachmentCount = (message:any) => message.attachments.length > 0;
    return incident?.ticket?.messages.some(attachmentCount);
  }

  setIncidentIconClass(status: string){
    if (status == "New")
      return "pi pi-circle-fill text-blue-700";
    else if (status =="Open")
      return "pi pi-circle text-blue-700";
    else if (status == "Pending")
      return "pi pi-question-circle text-purple-400";
    else if (status == "Resolved")
      return "pi pi-check-circle text-green-400";
    else if (status == "Note")
      return "pi pi-comment text-yellow-400";
    else if (status == "Attachment")
      return "pi pi-paperclip text-bluegray-400";
    else
      return "";
  }
  
  createGoFMX(incident: any)
  {
    this.opsappService.createGoFMX(incident).then(data => {
      this.messageService.add({severity:'success', summary:'GoFMX ticket created successfully!'});
      this.refreshIncidents();
    }).catch(() => {
      this.messageService.add({severity:'error', summary:'Couldn\'t create GoFMX ticket.'});
    });
  }
}
